import { useFetchOne } from '@/hooks/useFetchOne';
import type { Employee } from '@/models/employee/types';
import { fetchEmployeeInfo } from '@/models/employee/service';

export function useEmployeeController(login: string | undefined) {
  return useFetchOne<Employee>(login ? () => fetchEmployeeInfo(login) : undefined);
}
